import { render } from "./DesktopFooterSocial.vue?vue&type=template&id=5e410557&scoped=true&ts=true"
import script from "./DesktopFooterSocial.vue?vue&type=script&lang=ts"
export * from "./DesktopFooterSocial.vue?vue&type=script&lang=ts"

import "./DesktopFooterSocial.vue?vue&type=style&index=0&id=5e410557&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e410557"]])

export default __exports__